import {Event} from 'main.core';

export class Modalschemes extends Event.EventEmitter {
    static instances = {};

    constructor(params = {}) {
        super();
        this.setEventNamespace('BX.Asteq.Catalog.Modalschemes');

        this.el = params.element;
        if (!this.el) {
            throw new Error('Необходимо передать элемент');
        }

        this.classes = {
            hidden: 'hidden',
        };
        this.attrs = {
            bg: 'data-modal-bg',
            closeButton: 'data-modal-close',
        };

        this.initControls();

        this.constructor.addInstance(this);

        if(params.buttonsCode) {
            document.querySelectorAll("[data-local-modal=\"" + params.buttonsCode + "\"]")
                .forEach((button) => {
                    button.addEventListener('click', this.onModalButtonClick.bind(this));
                });
        }
    }

    initControls() {
        this.el.querySelectorAll('[' + this.attrs.closeButton + ']')
            .forEach((el) => el.addEventListener('click', this.onClose.bind(this), true));

        this.el.querySelectorAll('[' + this.attrs.bg + ']')
            .forEach((el) => el.addEventListener('click', this.onBackgroundClose.bind(this, el), true));

        if (this.el.hasAttribute(this.attrs.bg)) {
            this.el.addEventListener('click', this.onBackgroundClose.bind(this, this.el), true);
        }
    }

    getId() {
        return this.el.id;
    }

    open(dataset) {
        this.presetFormFields(dataset);
        this.el.classList.remove(this.classes.hidden);
        this.el.removeAttribute('aria-hidden');
        document.body.classList.add('overflow-hidden');
        this.emit('open');
    }

    presetFormFields(dataset){
        this.applyValues({
            PRODUCT_NAME: dataset.name,
            PRODUCT_ARTICLE: dataset.article,
        });
    }

    applyValues(values = {}) {
        for (let code in values) {
            const inputEl = this.el.querySelector(`[data-code="${code}"]`);
            if (!inputEl) {
                continue;
            }

            inputEl.value = values[code];
        }
    }

    close() {
        this.el.classList.add(this.classes.hidden);
        this.el.setAttribute('aria-hidden', true);
        document.body.classList.remove('overflow-hidden');
        this.emit('close');
    }

    onClose(e) {
        this.close();
    }

    onBackgroundClose(bgElement, e) {
        if (e.target != bgElement) {
            return;
        }
        this.close();
    }

    onModalButtonClick(e) {
        this.open(e.target.dataset);
    }

    static getInstance(modalId) {
        const modal = this.instances[modalId];
        if (!modal) {
            return null;
        }

        return modal;
    }

    static addInstance(modal) {
        const modalId = modal.getId();
        if (this.instances[modalId]) {
            console.warn('Модальное окно с таким id уже создано.');
            return;
        }
        this.instances[modalId] = modal;
    }
}